var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ErrorPlankk'),_c('PrimaryHeader'),_c('b-container',{class:_vm.$style.container,attrs:{"fluid":""}},[_c('b-row',{staticClass:"parent-row"},[_c('b-col',{class:_vm.$style.bodyContainer},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }